angular.module('iw.frontyard.error')
    .config(function ($provide, $httpProvider) {
        $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
            return function (exception, cause) {
                var PublicErrorManager = $injector.get('PublicErrorManager');
                PublicErrorManager.handleException(exception, cause);
                $delegate(exception, cause);
            };
        }]);


        $httpProvider.interceptors.push('PublicErrorManager');

    });
